export default {
    news: 'NOVITÀ',
    raiders: 'GUIDE',
    world_view: 'LEGGENDE',
    ugc: 'CONTENUTI UTENTI',
    hot_news: 'TENDENZE',
    recommend: 'PER TE',
    download: 'Scarica ora',
    empty_data: 'Nessun altro dato disponibile.',
    more: 'Altro',
    detail: 'DETTAGLI',
    collapse: 'Meno',
    home_title: 'Forum',
    top: 'TOP',

    
    team_simulator: 'Team Builder',
    simulator_hero: `Tap "+" to select Heroes and Relics;`,
    active_synergy_title: 'Hero Synergies',
    simulator_synergy: 'Click the synergy icon below to activate it',
    team_hero: 'Heroes',
    actived_synergy: 'Activated Hero Synergies',
    checkall_synergy: 'Activate All',
    synergy_effects: 'Hero Synergy Effects',
    tj_team: 'Other Compositions',
    query_link: 'View details',
    save_image: 'Save',
    share_image: 'Share',
    artifact: 'Relic',
    base_synergy: 'Valkyrie Synergies',
    faction_synergy: 'Faction Synergies',
    rune_synergy: 'Rune Synergies',
    hero_detail: 'Details',
    add_hero: 'Add Heroes',
    add_artifact: 'Add Relics',

    relic_synergy_title: 'Relic Synergy',
    relic_effects: 'Relic Synergy Effects',
    actived_relic_synergy: 'Activated Relic Synergies',
    relic_kind: 'Type'
}